<script lang="ts">
    import { fade } from "svelte/transition"
    import { sprache } from "../store"

    export let m: Media

    let modalOpen = false

    const handleImgClick = (e) => {
        if (e == "application/pdf") window.open("/api/media/" + m.id + "/" + m.file.src, "_blank").focus()
        else modalOpen = true
        console.log("handleImgClick", m)
    }

    const handleDownload = (e) => {
        if (
            confirm(
                "Alle Inhalte des Internetauftritts VDE 8 sind urheberrechtlich geschützt und dürfen nur mit schriftlicher Genehmigung der Deutschen Bahn AG ganz oder teilweise vervielfältigt, bearbeitet, verbreitet, öffentlich wiedergegeben oder in sonstiger Form genutzt werden."
            )
        ) {
        } else {
            e.preventDefault()
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
{#if modalOpen}
    <section class="lightbox" in:fade out:fade on:click|self="{() => (modalOpen = false)}">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="lb-content">
            <span class="close" on:click="{() => (modalOpen = false)}"></span>
            {#if m.external?.type != "Keine" && m.external?.type != undefined}
                {#if m.external?.type?.toLowerCase() == "youtube" || m.external?.url?.toLowerCase().includes("youtube")}
                    <db-youtube
                        class="youtube {m.external?.ratio == '4:3' ? 'ratio-4-3' : 'ratio-16-9'}"
                        width="100%"
                        headline="Wir benötigen Ihre Zustimmung, um YouTube zu laden!"
                        description="Wenn Sie dieses Video anklicken, wird Ihnen ein externer Inhalt von YouTube (www.youtube.com) angezeigt. Welche Daten von YouTube verarbeitet werden, entzieht sich unserer Kenntnis und Einflussnahme. Weitere Informationen finden Sie in unseren <a href='/datenschutz' target='_blank'>Datenschutzhinweisen</a>."
                        src="{m.external?.url.replace('http://', 'https://')}"></db-youtube>
                    <div class="caption">
                        {m.title ? m.title[$sprache] : ""}{m.author ? " " + m.author[$sprache] : ""}
                    </div>
                {:else if m.external?.type == "Infografik"}
                    <iframe
                        class="infografik ratio-16-9"
                        src="{m.external?.url.replace('http://', 'https://')}"
                        title="{(m.title && m.title[$sprache]) || m.filename}"></iframe>
                    <div class="caption">
                        {m.title ? m.title[$sprache] : ""}{m.author ? " " + m.author[$sprache] : ""}
                    </div>
                {/if}
            {:else if m.file?.type == "image/jpeg" || m.file?.type == "image/png"}
                <img
                    src="/api/media/{m.id}/{m.file?.src || m.preview?.src}?filter=l"
                    alt="{(m.title && m.title[$sprache]) || m.filename}"
                />
                <div class="caption">
                    {#if m.date}
                        <div class="datum">
                            <span>{new Date(m.date).getDate()}</span>
                            <span
                                >{new Date(m.date).toLocaleString($sprache == "de" ? "de-DE" : "en-US", {
                                    month: "long",
                                })}</span
                            > <span>{new Date(m.date).getFullYear()}</span>
                        </div>
                    {/if}
                    <strong>
                        {@html (m.title && m.title[$sprache]) || "<span class='filename'>" + m.filename + "</span>"}
                    </strong>
                    <br />{(m.author && m.author[$sprache]) || ""}
                    <!-- svelte-ignore a11y-missing-content -->
                    <a
                        href="/api/media/{m.id}/{m.preview?.src || m.file?.src}"
                        target="_blank"
                        class="icon download"
                        on:click="{(e) => handleDownload(e)}"
                        download="{m.filename}"></a>
                </div>
            {/if}
        </div>
    </section>
{/if}
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="item-header" on:click="{() => handleImgClick(m.file?.type)}">
    {#if m.file?.type == "application/pdf"}
        <img
            src="/api/media/{m.id}/{m.preview?.src || m.file?.src}?filter=m"
            alt="{(m.title && m.title[$sprache]) || m.filename}"
        />
    {/if}
    {#if m.file?.type == "image/jpeg" || m.file?.type == "image/png"}
        <img
            src="/api/media/{m.id}/{m.file?.src || m.preview?.src}?filter=m"
            alt="{(m.title && m.title[$sprache]) || m.filename}"
        />
    {/if}
    <div class="item-infos">
        {#if m.date}
            <div class="datum">
                <span>{new Date(m.date).getDate()}</span><span
                    >{new Date(m.date).toLocaleString($sprache == "de" ? "de-DE" : "en-US", {
                        month: "short",
                    })}</span
                ><span>{new Date(m.date).getFullYear()}</span>
            </div>
        {/if}
        <div class="label"><span class="icon"></span></div>
    </div>
</div>
